<template>
	<form @submit.prevent="handleSubmit(item)">
		<div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
			<label for="_name" class="control-label">Nazwa</label>
			<input v-model="item.name" type="text" id="_name" class="form-control" />
			<span v-if="errors && errors.name" class="help-block" id="_name_helpBlock">{{ errors.name }}</span>
		</div>
		<div :class="{ 'form-group': true, 'has-error': (errors && errors.nip) }">
			<label for="_nip" class="control-label">NIP</label>
			<input v-model="item.nip" type="text" id="_nip" class="form-control" />
			<span v-if="errors && errors.nip" class="help-block" id="_nip_helpBlock">{{ errors.nip }}</span>
		</div>
		<div :class="{ 'form-group': true, 'has-error': (errors && errors.regon) }">
			<label for="_regon" class="control-label">REGON</label>
			<input v-model="item.regon" type="text" id="_regon" class="form-control" />
			<span v-if="errors && errors.regon" class="help-block" id="_regon_helpBlock">{{ errors.regon }}</span>
		</div>
		<div :class="{ 'form-group': true, 'has-error': (errors && errors.address && errors.address.street) }">
			<label for="_address_street" class="control-label">Ulica</label>
			<input v-model="item.address.street" type="text" id="_address_street" class="form-control" />
			<span v-if="errors && errors.address && errors.address.street" class="help-block" id="_address_street_helpBlock">{{ errors.address.street }}</span>
		</div>
		<div :class="{ 'form-group': true, 'has-error': (errors && errors.address && errors.address.number) }">
			<label for="_address_number" class="control-label">Numer domu</label>
			<input v-model="item.address.number" type="text" id="_address_number" class="form-control" />
			<span v-if="errors && errors.address && errors.address.number" class="help-block" id="_address_number_helpBlock">{{ errors.address.number }}</span>
		</div>
		<div :class="{ 'form-group': true, 'has-error': (errors && errors.address && errors.address.postalCode) }">
			<label for="_address_postalCode" class="control-label">Kod pocztowy</label>
			<input v-model="item.address.postalCode" type="text" id="_address_postalCode" class="form-control" />
			<span v-if="errors && errors.address && errors.address.postalCode" class="help-block" id="_address_postalCode_helpBlock">{{ errors.address.postalCode }}</span>
		</div>
		<div :class="{ 'form-group': true, 'has-error': (errors && errors.address && errors.address.city) }">
			<label for="_address_city" class="control-label">Miasto</label>
			<input v-model="item.address.city" type="text" id="_address_city" class="form-control" />
			<span v-if="errors && errors.address && errors.address.city" class="help-block" id="_address_city_helpBlock">{{ errors.address.city }}</span>
		</div>
		<div :class="{ 'form-group': true, 'has-error': (errors && errors.cessionAvailable) }">		
			<b-form-checkbox v-model="item.cessionAvailable" id="_cessionAvailable">Cesja możliwa</b-form-checkbox>	
			<span v-if="errors && errors.cessionAvailable" class="help-block" id="_cessionAvailable_helpBlock">{{ errors.cessionAvailable }}</span>
		</div>
		<div :class="{ 'form-group': true, 'has-error': (errors && errors.comments) }">
			<label for="_comments" class="control-label">Uwagi</label>
			<input v-model="item.comments" type="text" id="_comments" class="form-control" />
			<span v-if="errors && errors.comments" class="help-block" id="_comments_helpBlock">{{ errors.comments }}</span>
		</div>

		<router-link :to="{ name: 'DebtorList' }" class="btn btn-primary"><span>Powrót</span><svg-icon name="back"/></router-link>
		<my-button text="Zapisz" icon="tick" type="submit"/>
	</form>
</template>

<script>
  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      }
    },
    computed: {
      item: function () {
        return this.initialValues ? this.initialValues : this.values;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?0e251285